import script from "./DiagReportPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagReportPanel.vue?vue&type=script&setup=true&lang=js"

import "./DiagReportPanel.vue?vue&type=style&index=0&id=94b302d8&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94b302d8"]])

export default __exports__